var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImageSelector',{attrs:{"showRemove":Boolean(_vm.avatarSrc)},on:{"onFileSelected":function($event){return _vm.$emit('onFileSelected')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }